import { useEffect } from 'react';

function PageMeta({ title, description, schema }) {
  useEffect(() => {
    document.title = `${title} | Cambia Digital`;
    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) descriptionTag.setAttribute('content', description);

    let script = document.getElementById('page-schema');
    if (schema) {
      if (!script) {
        script = document.createElement('script');
        script.id = 'page-schema';
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    } else if (script) {
      script.remove();
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [title, description, schema]);

  return null;
}

export default PageMeta;